// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgj_a","AdSlotBranding__desktop":"bgj_b","AdSlotBranding__mobile":"bgj_c"};